<template>
  <div class="item-container">
    <div class="custom-card-title">{{ lessons[0].lesson_name }}</div>
    <div class="custom-card-button-container">
      <div class="button" :id="`lesson-card-basic-${lessons[0].lesson_id}`">
        <b-button
          :variant="lessons[0].locked ? 'outline-secondary' : 'success'"
          @click="basicButtonClickedHandler"
          :disabled="lessons[0].locked"
        >{{$t('Typing.basic')}}</b-button>
      </div>
      <b-tooltip
        v-if="lessons[0].locked"
        :target="`lesson-card-basic-${lessons[0].lesson_id}`"
        placement="bottom"
        noninteractive
      >{{ $t('Typing.notUnlockedYet') }}</b-tooltip>

      <div class="button" :id="`lesson-card-intermediate-${lessons[1].lesson_id}`">
        <b-button
          :variant="lessons[1].locked ? 'outline-secondary' : 'success'"
          @click="intermediateButtonClickedHandler"
          :disabled="lessons[1].locked"
        >{{$t('Typing.intermediate')}}</b-button>
      </div>
      <b-tooltip
        v-if="lessons[1].locked"
        :target="`lesson-card-intermediate-${lessons[1].lesson_id}`"
        placement="bottom"
        noninteractive
      >{{ $t('Typing.notUnlockedYet') }}</b-tooltip>

      <div class="button" :id="`lesson-card-advanced-${lessons[2].lesson_id}`">
        <b-button
          :variant="lessons[2].locked ? 'outline-secondary' : 'success'"
          v-on:click="advancedButtonClickedHandler"
          :disabled="lessons[2].locked"
        >{{$t('Typing.advanced')}}</b-button>
      </div>
      <b-tooltip
        v-if="lessons[2].locked"
        :target="`lesson-card-advanced-${lessons[2].lesson_id}`"
        placement="bottom"
        noninteractive
      >{{ $t('Typing.notUnlockedYet') }}</b-tooltip>
    </div>
  </div>
</template>

<script lang='js'>
import Vue from 'vue'

const TypingSingleLessonCard = Vue.extend({
  name: 'TypingSingleLessonCard',
  components: {
  },
  props: {
    lessons: {
      type: Array,
      required: true
    }
  },
  methods: {
    basicButtonClickedHandler () {
      let typingSingleBasicLesson = this.lessons[0]
      this.$router.push({
        name: 'typingSingleBasic',
        params: {
          lessonId: typingSingleBasicLesson.lesson_id,
          currentLesson: typingSingleBasicLesson
        }
      })
    },
    intermediateButtonClickedHandler () {
      let typingSingleIntermediateLesson = this.lessons[1]
      this.$router.push({
        name: 'typingSingleIntermediate',
        params: {
          lessonId: typingSingleIntermediateLesson.lesson_id,
          currentLesson: typingSingleIntermediateLesson
        }
      })
    },
    advancedButtonClickedHandler () {
      let typingSingleAdvancedLesson = this.lessons[2]
      this.$router.push({
        name: 'typingSingleAdvanced',
        params: {
          lessonId: typingSingleAdvancedLesson.lesson_id,
          currentLesson: typingSingleAdvancedLesson
        }
      })
    }
  }
})

export default TypingSingleLessonCard
</script>

<style lang='scss' scoped>
@import "../styles/lessonCardStyles.scss";
</style>
